import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
// import Backdrop from "@material-ui/core/Backdrop";
import Chart, { CrosshairMode } from "kaktana-react-lightweight-charts";
import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router";
import { DialogContent, DialogTitle, IconButton } from "@material-ui/core";

import { useSelector } from "react-redux";
// import loaderGif from "../../assets/img/loader.gif";
import BuySellCards from "../../components/BuySellCards";
import OrdersTab from "../../components/OrdersTabs";
import TradeAppBar from "../../components/TradeAppBar";
// import FooterWithContent from "../../components/StaticComp/Footer/FooterWithContent";
import { CoinContext } from "../../contexts/CoinContext";
import { PRICES_URL, REACT_APP_PROD_URL } from "../../services/configs";
// import ReactComponent from "./../../assets/icons/infoIcon.svg";
import NewIcon from "./../../assets/icons/newIcon.svg";
import InfoIcon from "./../../assets/icons/infoIcon.svg";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { withStyles } from "@material-ui/core";
import Zoom from "@material-ui/core/Zoom";
import useResizer from "./../../services/useResizer";
import fetcher from "../../api/swr_fetcher";
import { useDispatch } from "react-redux";
import { useDialog } from "../../contexts/DialogProvider";
import CloseIcon from "@material-ui/icons/Close";

const StyledTooltip = withStyles({
  tooltipPlacementTop: {
    marginLeft: "-150px",
    fontSize: "14px",
    lineHeight: "1.2rem",
    // margin: "4px 0 4px -8px",
  },
})(Tooltip);

export default function Tradetab(props) {
  const isMobile = useResizer();
  const prices = useSelector((state) => state.priceReducer.PRICES);
  const params = useParams();
  const classes = useStyles();
  const theme = useTheme();
  let coin = "BTC";
  const [coinName, setCoinName] = useState("BTC");
  const [coinConfig, setCoinConfig] = useState(null);
  const [wick, setWick] = useState({ high: null, low: null });
  const [sellWick, setSellWick] = useState({ high: null, low: null });
  const [loading, setLoading] = useState(false);
  const [infoButton, setInfoButton] = useState(false);

  var chart = null;

  const { handleClickAlert } = useContext(CoinContext);
  const loginId = useSelector((state) => state.trading.LOGIN_ID);
  const [chartData, setChartData] = React.useState([]);
  const [chartSellData, setChartSellData] = React.useState([]);

  const [openMissingDocsDialog, closeMissingDocsDialog] = useDialog();

  const chartProperties = {
    // width: 500,
    // height: 350,
    timeScale: {
      timeVisible: true,
      secondsVisible: false,
    },
    crosshair: {
      mode: CrosshairMode.Normal,
    },
    localization: {
      locale: "en-US",
      priceFormatter: (price) => {
        if (coinConfig) {
          if (coinConfig.decimalInr) {
            return parseFloat(price).toFixed(coinConfig.decimalInr);
          } else {
            return parseFloat(price).toFixed(2);
          }
        } else {
          return parseFloat(price).toFixed(2);
        }
      },
    },
  };

  const [chartTime, setChartTime] = React.useState("1h");
  const [chartType, setChartType] = React.useState("BUY_CHART");
  const dispatch = useDispatch();
  const handleChartTime = (event, newTime) => {
    if (newTime !== null) {
      setChartTime(newTime);
    }
  };

  const handleChartType = (event, newType) => {
    if (newType !== null) {
      setChartType(newType);
    }
    setInfoButton(true);
  };

  const changeNewToInfo = () => {
    setInfoButton(true);
  };

  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    console.log("FALSE");
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    console.log("TRUE");
    setOpen(true);
    // setTimeout(setOpen(false), 5000);
  };

  // in milliseconds
  var timeDict = {
    "1m": 60000,
    "5m": 300000,
    "15m": 900000,
    "30m": 1800000,
    "1h": 3600000,
    "1d": 86400000,
    "7d": 604800000,
    "30d": 2592000000,
  };

  // const val = queryString.parse(props.location.search);
  // const status = val.status;

  useEffect(() => {
    dispatch({ type: "SET_MOBILE_TAB", payload: 1 });

    // if (window.innerWidth < 768) {
    //   setTimeout(() => {
    // document.querySelector(
    //   "#fc_frame, #fc_frame.fc-widget-normal"
    // ).style.bottom = "80px !important";
    //   }, 4000);
    // }
  }, []);

  useEffect(() => {
    if (params.coin) {
      dispatch({
        type: "SET_SELECTED_COIN",
        selectedCoin: params.coin,
      });
    } else {
      dispatch({
        type: "SET_SELECTED_COIN",
        selectedCoin: "BTC",
      });
    }

    document.title = `PocketBits - Buy, Sell & Hold (${params.coin}) in INR`;
  }, [params.coin]);

  if (
    props.match.params.coin !== ":coin" &&
    props.match.params.coin !== undefined
  ) {
    coin = props.match.params.coin;
  }

  useEffect(() => {
    let clicky_custom = {};
    clicky_custom.href = "/trade";
    clicky_custom.title = "Trade Page";
    clicky_custom.session = {
      email: loginId,
    };
    clicky_custom.timer = 200;

    if (coin !== undefined) {
      setCoinName(props.match.params.coin);
    }
  }, [coin, props.match.params.coin]);

  useEffect(() => {
    fetcher(`/v1/coinConfig/${coin}`)
      .then((data) => {
        if (!data.status) {
          setCoinConfig(data);
          // console.log("coin config", data);
        }
      })
      .catch((err) => {
        // console.error(err);
      });
  }, [coin]);

  useEffect(() => {
    setLoading(true);
    // fetching historical data for the new coin and clearing prev wick values
    updateChart();
    updateSellChart();
    // time is in seconds, 19800 seconds is 5hrs 30mins (for local time)
    function updateChart() {
      fetch(
        PRICES_URL +
          `/v1/historicBuy/${coin}INR?page=0&pageSize=1000&window=${chartTime}`
      )
        .then((res) => res.json())
        .then((data) => {
          const cdata = data.content.map((d) => {
            return {
              time: d[0] / 1000 + (19800 - 60),
              open: d[1],
              high: d[3],
              low: d[4],
              close: d[2],
            };
          });

          setWick({ high: null, low: null });

          // let dat = new Date(prices[`${coin}INR`]["at"])
          // cdata.unshift({
          //   time: prices[`${coin}INR`]["at"]/1000,
          //   open: 0,
          //   high: 0,
          //   low: 0,
          //   close: 0
          // })

          // console.log(data[0])
          setChartData(cdata);
          setLoading(false);
        })
        .catch((err) => {
          // console.error(err)
        });
    }

    function updateSellChart() {
      fetch(
        PRICES_URL +
          `/v1/historicSell/${coin}INR?page=0&pageSize=1000&window=${chartTime}`
      )
        .then((res) => res.json())
        .then((data) => {
          const cdata = data.content.map((d) => {
            return {
              time: d[0] / 1000 + (19800 - 60),
              open: d[1],
              high: d[3],
              low: d[4],
              close: d[2],
            };
          });

          setSellWick({ high: null, low: null });

          // let dat = new Date(prices[`${coin}INR`]["at"])
          // cdata.unshift({
          //   time: prices[`${coin}INR`]["at"]/1000,
          //   open: 0,
          //   high: 0,
          //   low: 0,
          //   close: 0
          // })

          // console.log(data[0])
          setChartSellData(cdata);
          setLoading(false);
        })
        .catch((err) => {
          // console.error(err)
        });
    }

    const interval = setInterval(() => updateChart(), timeDict[chartTime]);
    return () => {
      clearInterval(interval);
    };
  }, [coin, chartTime]);

  useEffect(() => {
    //updating candle
    if (
      (prices && chartData.length >= 2) ||
      (chartData.length >= 2 && prices)
    ) {
      if (prices[`${coin}INR`]) {
        //getting high wick
        if (wick.high === null) {
          setWick({ ...wick, high: prices[`${coin}INR`]["a"] });
        } else {
          if (wick.high <= prices[`${coin}INR`]["a"]) {
            setWick({ ...wick, high: prices[`${coin}INR`]["a"] });
          }
        }
        //getting low wick
        if (wick.low === null) {
          setWick({ ...wick, low: prices[`${coin}INR`]["a"] });
        } else {
          if (wick.low >= prices[`${coin}INR`]["a"]) {
            setWick({ ...wick, low: prices[`${coin}INR`]["a"] });
          }
        }
        // time is in seconds and the lastest candle is one min ahead of historic data

        setChartData((prevData) => [
          ...prevData,
          {
            time: chartData[0].time + timeDict[chartTime] / 1000,
            open: chartData[0].close,
            high: wick.high ? wick.high : prices[`${coin}INR`]["a"],
            low: wick.low ? wick.low : prices[`${coin}INR`]["a"],
            close: prices[`${coin}INR`]["a"],
          },
        ]);
      }
    }
  }, [coin, prices]);

  useEffect(() => {
    //updating candle
    if (
      (prices && chartSellData.length >= 2) ||
      (chartSellData.length >= 2 && prices)
    ) {
      if (prices[`${coin}INR`]) {
        //getting high wick
        if (sellWick.high === null) {
          setSellWick({ ...sellWick, high: prices[`${coin}INR`]["b"] });
        } else {
          if (sellWick.high <= prices[`${coin}INR`]["b"]) {
            setSellWick({ ...sellWick, high: prices[`${coin}INR`]["b"] });
          }
        }
        //getting low wick
        if (sellWick.low === null) {
          setSellWick({ ...sellWick, low: prices[`${coin}INR`]["b"] });
        } else {
          if (sellWick.low >= prices[`${coin}INR`]["b"]) {
            setSellWick({ ...sellWick, low: prices[`${coin}INR`]["b"] });
          }
        }
        // time is in seconds and the lastest candle is one min ahead of historic data

        setChartSellData((prevData) => [
          ...prevData,
          {
            time: chartSellData[0].time + timeDict[chartTime] / 1000,
            open: chartSellData[0].close,
            high: sellWick.high ? sellWick.high : prices[`${coin}INR`]["b"],
            low: sellWick.low ? sellWick.low : prices[`${coin}INR`]["b"],
            close: prices[`${coin}INR`]["b"],
          },
        ]);
      }
    }
  }, [coin, prices]);

  function handleOpenMissingDocs() {
    openMissingDocsDialog({
      children: (
        <>
          <DialogTitle className="p-0  relative">
            <IconButton
              className="h-max p-0 absolute right-2 top-2"
              onClick={() => {
                closeMissingDocsDialog();
              }}
            >
              <CloseIcon style={{ color: "#676879" }} />
            </IconButton>
          </DialogTitle>
          <DialogContent className="h-[150px] text-center flex items-center justify-center  px-4">
            <strong className="text-[#FFFFFF] text-lg md:text-2xl">
              Your account is under review, kindly contact support via chat.
            </strong>
          </DialogContent>
        </>
      ),
    });
  }

  useEffect(() => {
    fetcher(`/v1/um/getKycDetails`).then((res) => {
      if (res.missingDocuments) {
        handleOpenMissingDocs();
      }
    });
    return () => {
      closeMissingDocsDialog();
    };
  }, []);

  return (
    <Grid container className={classes.root}>
      {/* xs={12} lg={8} xl={9} */}
      <Grid
        item
        className={classes.stuff}
        style={{ marginTop: !isMobile ? "-9px" : "-17px" }}
      >
        {coinConfig ? (
          <TradeAppBar
            coin={{
              symbol: coin,
              config: coinConfig,
              chartType: chartType,
            }}
          />
        ) : null}

        {/* LightWeightChart */}
        <div
          style={{
            marginTop: "10px",
            // minWidth: "450px",
            minHeight: "320px",
            background: theme.palette.type === "dark" ? "#141822" : "white",
            paddingTop: "10px",
            paddingLeft: "14px",
            paddingRight: "10px",
            paddingBottom: "7px",
            // boxShadow:
            //   "0px 20px 30px -10px rgba(104, 142, 176, 0.15) !important",
            borderRadius: "25px",
            position: "relative",
            zIndex: 10,
          }}
        >
          {loading ? (
            <div style={{ textAlign: "center" }}>
              {/* <CircularProgress
                color="primary"
                style={{ marginTop: "10%", marginBottom: "10%" }}
              /> */}
              {/* <img
                src={loaderGif}
                alt="loading..."
                style={{
                  marginTop: "10%",
                  marginBottom: "10%",
                  width: "180px",
                  height: "auto",
                }}
              /> */}
            </div>
          ) : (
            <div>
              <ToggleButtonGroup
                style={{
                  width: isMobile ? "100%" : null,
                  justifyContent: isMobile ? "center" : null,
                }}
                value={chartTime}
                exclusive
                onChange={handleChartTime}
                aria-label="text alignment"
              >
                <ToggleButton
                  value="1m"
                  className="normal-case"
                  aria-label="1m"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  1min
                </ToggleButton>
                <ToggleButton
                  value="5m"
                  aria-label="5m"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  5min
                </ToggleButton>
                <ToggleButton
                  value="15m"
                  aria-label="15m"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  15min
                </ToggleButton>
                <ToggleButton
                  value="30m"
                  aria-label="30m"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  30min
                </ToggleButton>
                <ToggleButton
                  value="1h"
                  aria-label="1h"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  1hr
                </ToggleButton>
                <ToggleButton
                  value="1d"
                  aria-label="1d"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  1d
                </ToggleButton>
                <ToggleButton
                  value="7d"
                  aria-label="7d"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                >
                  7d
                </ToggleButton>
                <ToggleButton
                  value="30d"
                  aria-label="30d"
                  className="normal-case"
                  style={{ padding: "8px", fontSize: "10px" }}
                  disabled
                >
                  30d
                </ToggleButton>
              </ToggleButtonGroup>

              <div
                style={{
                  marginTop: isMobile ? "8px" : null,
                  marginLeft: isMobile ? "auto" : null,
                  justifyContent: isMobile ? "center" : null,
                  marginRight: isMobile ? "auto" : "36px",
                  float: isMobile ? null : "right",
                  position: "relative",
                  zIndex: "999",
                  height: "35px",
                  display: "flex",
                }}
              >
                <ToggleButtonGroup
                  exclusive
                  value={chartType}
                  onChange={handleChartType}
                  style={{ height: "35px" }}
                >
                  <ToggleButton
                    value="BUY_CHART"
                    style={
                      chartType === "BUY_CHART"
                        ? {
                            borderBottomColor: "#3AC4AB",
                            borderBottomWidth: "3px",
                            background:
                              theme.palette.type === "dark"
                                ? "#1a2826"
                                : "#f0fffd",
                            fontSize: "10px",
                            color: "#3AC4AB",
                            fontWeight: "bold",
                          }
                        : { fontSize: "10px" }
                    }
                  >
                    Buy Chart
                  </ToggleButton>
                  <ToggleButton
                    value="SELL_CHART"
                    style={
                      chartType === "SELL_CHART"
                        ? {
                            borderBottomColor: "#DB747B",
                            borderBottomWidth: "3px",
                            background:
                              theme.palette.type === "dark"
                                ? "rgb(235, 112, 112, 0.2)"
                                : "#F4C9C9",
                            fontSize: "10px",
                            color: "#DB747B",
                            fontWeight: "bold",
                          }
                        : { fontSize: "10px" }
                    }
                  >
                    Sell Chart
                  </ToggleButton>
                </ToggleButtonGroup>

                {/* <ClickAwayListener onClickAway={handleTooltipClose}> */}
                {/* <div style={{ position: "relative", top: "8px", left: "5px" }}>
                  <Tooltip
                    title={
                      <>
                        The <b>Buy Chart</b> is the representation of historic
                        buying price data.
                        <br />
                        <br />
                        The <b>Sell Chart</b> is the representation of historic
                        selling price data.
                      </>
                    }
                    placement="top-start"
                    TransitionComponent={Zoom}
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    {infoButton ? (
                      <img
                        src={InfoIcon}
                        alt="loading..."
                        style={{ position: "relative" }}
                      />
                    ) : (
                      <img
                        src={NewIcon}
                        alt="loading..."
                        style={{ position: "relative" }}
                      />
                      // <InfoIcon
                      //   // onClick={handleTooltipOpen}
                      //   style={{ position: "relative" }}
                      // />
                    )}
                  </Tooltip>
                </div> */}
                {/* </ClickAwayListener> */}
              </div>
              <div className="relative">
                {/* <div className="absolute md:hidden w-full h-full z-10"></div> */}
                {chartData ? (
                  chartType == "BUY_CHART" ? (
                    <Chart
                      options={chartProperties}
                      candlestickSeries={[
                        {
                          data: chartData,
                          legend: `${coin}/INR ${chartTime} • `,
                          options: {
                            upColor: "#0DCB81",
                            downColor: "#CF304A",
                            borderVisible: false,
                            wickVisible: true,
                            // borderColor: "#000000",
                            // wickColor: "#000000",
                            borderUpColor: "#0DCB81",
                            borderDownColor: "#CF304A",
                            wickUpColor: "#0DCB81",
                            wickDownColor: "#CF304A",
                          },
                        },
                      ]}
                      autoWidth
                      height={280}
                      darkTheme={theme.palette.type === "dark" ? true : false}
                    />
                  ) : (
                    <Chart
                      options={chartProperties}
                      candlestickSeries={[
                        {
                          data: chartSellData,
                          legend: `${coin}/INR ${chartTime} • `,
                          options: {
                            upColor: "#0DCB81",
                            downColor: "#CF304A",
                            borderVisible: false,
                            wickVisible: true,
                            // borderColor: "#000000",
                            // wickColor: "#000000",
                            borderUpColor: "#0DCB81",
                            borderDownColor: "#CF304A",
                            wickUpColor: "#0DCB81",
                            wickDownColor: "#CF304A",
                          },
                        },
                      ]}
                      autoWidth
                      height={280}
                      darkTheme={theme.palette.type === "dark" ? true : false}
                    />
                  )
                ) : (
                  // <CircularProgress
                  //   color="primary"
                  //   style={{ marginTop: "10%", marginBottom: "10%" }}
                  // />
                  // <img src={loaderGif} alt="loading..." />
                  <></>
                )}
              </div>
              <div
                style={{
                  position: "relative",
                  marginRight: "7%",
                  textAlign: "right",
                }}
              >
                Charts by{" "}
                <a
                  href="https://in.tradingview.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#3AC4AB" }}
                >
                  TradingView
                </a>
              </div>
            </div>
          )}
        </div>

        <Grid item xs={12}>
          {coinConfig ? (
            <BuySellCards
              openMissingDocsDialog={handleOpenMissingDocs}
              coin={{
                symbol: `${coin}INR`,
                config: coinConfig,
              }}
            />
          ) : null}
        </Grid>
      </Grid>

      {/*This is visible only for screen sizes md, lg, xl, xs={12} lg={3} xl={3} */}
      <Hidden smDown>
        <Grid item className={classes.order}>
          <OrdersTab />
        </Grid>
      </Hidden>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-33px",
  },
  stuff: {
    [theme.breakpoints.up("lg")]: {
      width: "71.4%",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  order: {
    [theme.breakpoints.up("lg")]: {
      marginLeft: "15px",
      // minWidth: "308px",
      width: "27%",
    },
    [theme.breakpoints.only("md")]: {
      minWidth: "100%",
      marginTop: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px",
    },
    // maxHeight: "85vh",
    // overflow: "scroll",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
